import { cn } from "@krea/shared/utils";

import type { IAuditLog } from "../types";

interface IProps {
  items: IAuditLog[];
  selectedItem: IAuditLog | null;
  filters: { q?: string };
  onChangeFilters: (next: { q?: string }) => void;
  onSelect: (item: IAuditLog) => void;
}

export const ActivityListPane = ({
  items,
  selectedItem,
  // filters/onChangeFilters wired for the (currently commented-out) search input
  filters: _filters,
  onChangeFilters: _onChangeFilters,
  onSelect,
}: IProps) => {
  return (
    <div className="flex h-full flex-col border-r">
      {/* <div className="border-b p-6">
        <Input
          value={filters.q}
          onChange={(e) => onChangeFilters({ ...filters, q: e.target.value })}
          placeholder="Search by endpoint, status, or ID..."
        />
      </div> */}

      <div className="flex-1 overflow-y-auto p-4">
        <div className="space-y-2">
          {items.map((x) => {
            const isActive = x.id === selectedItem?.id;

            return (
              <button
                key={x.id}
                type="button"
                onClick={() => onSelect(x)}
                className={cn(
                  "cursor-pointer text-left w-full p-4 rounded-lg border transition-all",
                  "hover:bg-primary-150",
                  isActive && "bg-primary-150 border-primary-300",
                )}
              >
                <div className="mb-2 flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3">
                    <div>
                      <div className="text-base-strong">{x.description}</div>
                      <div className="text-helper mt-0.5">
                        {new Date(x.timestamp).toLocaleString()}
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            );
          })}

          {items.length === 0 ? (
            <div className="text-base p-4">
              No activity matches your filters.
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
